import { combineReducers } from 'redux'

import rendersReducer, * as fromRenders from './reducer.renders'

export default combineReducers({
	renders: rendersReducer,
})

// State accessors

export const getRenderByKey = (state, key) => fromRenders.getRenderByKey(state.renders, key)
export const getRenderFetchingByKey = (state, key) => fromRenders.getFetchingByKey(state.renders, key)
export const getRenderErrorByKey = (state, key) => fromRenders.getErrorByKey(state.renders, key)
